document.addEventListener('DOMContentLoaded', function () {
    var heroBlocks = document.querySelectorAll('.hero-block');

    for (var i = 0; i < heroBlocks.length; i++) {
        var firstHeroBlock = heroBlocks[0];

        firstHeroBlock.classList.add('first-hero-block');
    }

    function heroFontSize() {
        for (var i = 0; i < heroBlocks.length; i++) {
            var heroBlock = heroBlocks[i];
            var heroBody = heroBlock.querySelector('.body');

            if (heroBody) {
                var numWords = heroBody.innerText.length;

                if ((numWords >= 1) && (numWords < 30)) {
                    heroBody.classList.add("font-size-xxl");
                }
                else if ((numWords >= 30) && (numWords < 40)) {
                    heroBody.classList.add("font-size-xl");
                }
                else if ((numWords >= 40) && (numWords < 55)) {
                    heroBody.classList.add("font-size-l");
                }
                else if ((numWords >= 55) && (numWords < 70)) {
                    heroBody.classList.add("font-size-n");
                }
                else {
                    heroBody.classList.add("font-size-s");
                }
            }
        }
    }

    heroFontSize();
});